/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `day` - Day
 * * `night` - Overnight
 * * `call` - Call
 * * `24h` - 24 Hour
 */
export enum ShiftRateTypesEnum {
    DAY = 'day',
    NIGHT = 'night',
    CALL = 'call',
    _24H = '24h',
}
